import MetalOImage from "@/images/metal_o@2x.png";
import MetalPImage from "@/images/metal_p@2x.png";
import MetalQImage from "@/images/metal_q@2x.png";
import MetalASImage from "@/images/metal_as@2x.png";
import MetalATImage from "@/images/metal_at@2x.png";

export default [
  {
    shape: "葫蘆",
    name: "福如雙鳳牡丹",
    code: "O",
    imagePath: MetalOImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 8,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "葫蘆",
    name: "福如雙龍獻珠",
    code: "P",
    imagePath: MetalPImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 8,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "葫蘆",
    name: "福如九品蓮",
    code: "Q",
    imagePath: MetalQImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 40,
      },
      gift: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "葫蘆",
    name: "財福葫蘆(直)",
    code: "AS",
    imagePath: MetalASImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 6,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "葫蘆",
    name: "財福葫蘆(橫)",
    code: "AT",
    imagePath: MetalATImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 6,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 6,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
];
